import React from 'react'

const TimeSlot = ({ slot, onClick }) => {
  const { formattedSlotName } = slot.attributes

  function handleClick() {
    onClick(formattedSlotName)
  }

  return (
    <a className="time-slot" key={slot.id} onClick={handleClick}>
      { formattedSlotName }
    </a>
  )
}

export default TimeSlot
